export const LOGO =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_ce4ccd92-f609-40b3-a070-ff511e16fbe5/artifacts/055283a774646404_Retro%20Green%20Dot-Matrix%20Replicant%20Logo.webp";

export const CITY_SHOT_A =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_ce4ccd92-f609-40b3-a070-ff511e16fbe5/artifacts/a9402e5753f6164e_image.webp";

export const CITY_SHOT_B =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_ce4ccd92-f609-40b3-a070-ff511e16fbe5/artifacts/7434e73c9f34a10a_image.webp";

export const CITY_URL = "https://city.replicantresearch.com";
export const LINKEDIN_URL = "https://www.linkedin.com/in/mancillamontero/";
export const QML_REPO_URL = "https://github.com/maximer-v/qml-unlocked";
export const PAPER_URL = "https://doi.org/10.1140/epjds/s40309-024-00238-0";
export const CYBERSYN_URL = "https://cybersyn.systems/";
export const EMAIL = "javier@replicantresearch.com";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};
